import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { ClientAuthProvider } from "./context/ClientAuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import KidsSwimPage from "./pages/KidsSwimPage";
import AboutPage from "./pages/AboutPage";
import PricingPage from "./pages/PricingPage";
import BookingPage from "./pages/BookingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./admin/AdminPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ClientAuthProvider>
          <LanguageProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/natation-enfants" element={<KidsSwimPage />} />
                  <Route path="/notre-histoire" element={<AboutPage />} />
                  <Route path="/tarifs" element={<PricingPage />} />
                  <Route path="/reservation" element={<BookingPage />} />
                  <Route path="/booking/success" element={<PaymentSuccessPage />} />
                  <Route path="/compte" element={<AccountPage />} />
                </Route>
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </LanguageProvider>
        </ClientAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
